import "./Labels.scss";
import { LabelsProps } from "/Models/Generated/LabelsProps";
import { LabelTheme } from "/Models/Generated/LabelTheme";
import { Label } from "/App.Components";
import { createSpreadableBem } from "/Helpers/createBem";

const Labels = ({ firstLabel, secondLabel, theme }: LabelsProps) => {
  const themes = {
    firstLabelFilled: theme === LabelTheme.Filled,
    secondLabelFilled:
      theme === LabelTheme.Mixed || theme === LabelTheme.Filled,
  };
  const bem = createSpreadableBem("labels-norad");
  return (
    <div {...bem("")}>
      {firstLabel && (
        <Label
          {...firstLabel}
          filled={themes.firstLabelFilled}
          outlined={!themes.firstLabelFilled}
        />
      )}
      {secondLabel && (
        <div {...bem("__second", { "--combine-borders": firstLabel })}>
          <Label
            {...secondLabel}
            filled={themes.secondLabelFilled}
            outlined={!themes.secondLabelFilled}
          />
        </div>
      )}
    </div>
  );
};

export default Labels;
